export default (theme) => ({
  thankYouPage: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 120,
    boxSizing: 'border-box',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '20px 38px',
      margin: '100px auto 0',
      height: 'calc(100vh - 130px)',
      width: 'calc(100% - 32px)',
      boxShadow: theme.custom.boxShadow,
      WebkitBoxShadow: theme.custom.boxShadow,
      background: theme.palette.background.white,
      borderRadius: 33,
    },
  },
  title: {
    textAlign: 'left',
    fontWeight: 500,
    fontSize: 48,
    color: theme.palette.primary.main,
    margin: '25px auto 0',
    [theme.breakpoints.down('xl')]: {
      fontSize: 32,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 20,
      textAlign: 'center',
    },
  },
  subTitle: {
    fontSize: 20,
    color: theme.palette.font.main,
    margin: '10px 0 60px',
    [theme.breakpoints.down('xl')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
  },
  mobileBreak: {
    display: 'none',
    [theme.breakpoints.down('md')]: {
      display: 'inline',
    },
  },
  textContainer: {
    width: 990,
    [theme.breakpoints.down('xl')]: {
      width: 660,
    },
    [theme.breakpoints.down('md')]: {
      width: 300,
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  animatedCheck: {
    width: 290,
    maxHeight: 290,
    height: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: 185,
    },
    [theme.breakpoints.down('md')]: {
      width: 155,
    },
  },
  check: {
    stroke: theme.palette.primary.main,
    strokeDasharray: 1000,
    strokeDashoffset: -100,
    WebkitAnimation: '$check 2s .35s ease-in-out forwards',
    animation: '$check 2s .35s ease-in-out forwards',
  },
  circle: {
    stroke: theme.palette.primary.main,
    strokeDasharray: 1000,
    strokeDashoffset: 0,
    WebkitAnimation: '$circle 1.5s 0s ease-in-out forwards',
    animation: '$circle 1.5s 0s ease-in-out forwards',
  },
  '@keyframes check': {
    '0%': {
      strokeDashoffset: -100,
    },
    '100%': {
      strokeDashoffset: 900,
    },
  },
  '@keyframes circle': {
    '0%': {
      strokeDashoffset: 1000,
    },
    '100%': {
      strokeDashoffset: 0,
    },
  },
});
